import { Box, Button, Divider, Stack, TextField, Typography, InputAdornment, CircularProgress, MenuItem, FormControl, InputLabel, Select, FormHelperText, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Paper, IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { useSnackbar } from "notistack";
import ModalComponent from "./modalComponent";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMemo, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import userServices from "../../services/userServices";
import bankServices from "../../services/bankServices";
import CustomIcon from "../customIcon";
import tokenTransferServices from "../../services/tokenTransferServices";
import MnemonicUploadModal from "./MnemonicUploadModal";
import CloseIcon from "@mui/icons-material/Close";
import TransferInitiated from "./TransferInitiated";
import Lottie from "lottie-react";
import warning from "../../animations/warning.json";
// TODO: Add hourglass.json animation file to src/animations/ and import it here
const DEBOUNCE_DELAY = 500;

const TransferTokenModal = ({ open, data, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useSelector((state) => state.user.data);
  const userId = useSelector((state) => state.user.data._id);
  const [addressDetails, setAddressDetails] = useState(null);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [addressError, setAddressError] = useState(null);
  const [bankAccount, setBankAccount] = useState([]);
  const [defaultBankId, setDefaultBankId] = useState("");
  const [transferInitiatedModal,setTransferInitiatedModal]=useState(false)
  const [isOptin,setIsOptin]=useState(false)
  const [termsAccepted, setTermsAccepted] = useState({
    peerToPeer: false,
    poolHolding: false,
    transactionFees: false,
    legalRight: false,
    allTerms: false,
  });
  const [dltWallet, setDltWallet] = useState([]);
  const [selectedDltAccount, setSelectedDltAccount] = useState(null);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [showMnemonicModal, setShowMnemonicModal] = useState(false);
  const [mnemonicOption, setMnemonicOption] = useState(""); // "manual" or "file"
  const [mnemonicInput, setMnemonicInput] = useState("");
  const [mnemonicFile, setMnemonicFile] = useState(null);
  const [showOptinModal, setShowOptinModal] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentReason, setCommentReason] = useState("");
  const [commentDocuments, setCommentDocuments] = useState([]);
  const [trnasactionId, setTrnasactionId] = useState(null);
  const [animating, setAnimating] = useState(false);
  // Debounce logic
  const [debouncedRecipientInput, setDebouncedRecipientInput] = useState("");
  const debounceTimerRef = useRef(null);
  useEffect(() => {
    if (showOptinModal) {
      setAnimating(true);
    }
  }, [showOptinModal]);
  const handleClose = (resetForm) => {
    if (resetForm) resetForm();
    setAddressDetails(null);
    setAddressError(null);
    setSelectedDltAccount(null);
    setShowSummaryModal(false);
    setShowMnemonicModal(false);
    setMnemonicOption("");
    setMnemonicInput("");
    setMnemonicFile(null);
    setSummaryData(null);
    setComments([]);
    setCommentReason("");
    setCommentDocuments([]);
    setShowOptinModal(false);
    setTermsAccepted({
      peerToPeer: false,
      poolHolding: false,
      transactionFees: false,
      legalRight: false,
      allTerms: false,
    });
    onClose?.();
    setAnimating(false);
    setTrnasactionId(null);
    setShowMnemonicModal(false);
    setDebouncedRecipientInput("");
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  };
function transferInitiated(isOptin){
  setTransferInitiatedModal(true);
  setTimeout(() => {
    setTransferInitiatedModal(false);
    if(isOptin){
      setShowSummaryModal(false);
      setShowMnemonicModal(true);
    }else{
      setShowSummaryModal(false);
      setShowOptinModal(true);
    }
  }, 4000);
  
}

  const handleFinalSubmit = async () => {
    try {
      const req = await tokenTransferServices.createTokenTransferTransaction(summaryData);
      if (req && req.success) {
        if (req.isOptIn) {
          transferInitiated(req.isOptIn);
          setTrnasactionId(req._id);
        } else {
          transferInitiated(false);
        }
      } else {
        enqueueSnackbar(req?.data?.message|| req?.message || "Something went wrong", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  const formatAddressShort = (addr) => {
    if (!addr) return "-";
    const str = String(addr);
    if (!isMobile) return str;
    if (str.length <= 14) return str;
    return `${str.slice(0, 6)}...${str.slice(-6)}`;
  };

  const handleTermsChange = (field) => (event) => {
    const newValue = event.target.checked;
    if (field === 'allTerms') {
      setTermsAccepted({
        peerToPeer: newValue,
        poolHolding: newValue,
        transactionFees: newValue,
        legalRight: newValue,
        allTerms: newValue,
      });
    } else {
      const newTermsAccepted = {
        ...termsAccepted,
        [field]: newValue,
      };
      const allIndividualChecked =
        newTermsAccepted.peerToPeer &&
        newTermsAccepted.poolHolding &&
        newTermsAccepted.transactionFees &&
        newTermsAccepted.legalRight;
      newTermsAccepted.allTerms = allIndividualChecked;
      setTermsAccepted(newTermsAccepted);
    }
  };

  const areAllTermsAccepted = termsAccepted.allTerms;

  useEffect(() => {
    
    setDltWallet(data?.dltAccount);
  }, [data, userId]);

  // Fetch recipient details using debounce
  useEffect(() => {
    if (!debouncedRecipientInput) {
      setAddressDetails(null);
      setAddressError(null);
      return;
    }
    

   

    let inputValue = debouncedRecipientInput.trim();
    const publicAddressRegex = /^[A-Z2-7]{58}$/;
    if (publicAddressRegex.test(inputValue)) {
      // Prevent transfer to own DLT
      const isSenderAddress = dltWallet === inputValue;
      if (isSenderAddress) {
        setAddressError("You cannot transfer tokens to your own DLT account");
        setAddressDetails(null);
        return;
      }
    }
 
    let isActive = true;
    setLoadingAddress(true);
    setAddressError(null);
    setAddressDetails(null);

    const fetch = async () => {
      try {
        // API requires { input } in req.body, input could be address, mobile, or email
        const response = await userServices.getPublicAddressDetails({ input: inputValue });
        if (!isActive) return;
        if (response && response.success) {
          setAddressDetails(response.data);
        } else {
          setAddressError(response?.data?.message || "Recipient not found or invalid");
        }
      } catch (error) {
        setAddressError("Failed to fetch recipient details");
      } finally {
        setLoadingAddress(false);
      }
    }
    fetch();

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line
  }, [debouncedRecipientInput, dltWallet]);

  // Yup validation schema (allow any non-empty input, backend verifies)
  const validationSchema = Yup.object().shape({
    transferToAddress: Yup.string()
      .trim()
      .required("Please enter the recipient's public id, email, or mobile"),
    transferQuantity: Yup.number()
      .typeError("Enter a valid transfer quantity")
      .required("Enter a valid transfer quantity")
      .min(1, "Quantity must be at least 1")
      .test('max-tokens', function (value) {
        const maxTokens = data?.frax || 0;
        if (value > maxTokens) {
          return this.createError({
            message: `Quantity exceeds tokens owned (${maxTokens})`
          });
        }
        return true;
      }),
  });

  const initialValues = {
    transferToAddress: "",
    transferQuantity: "",
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={() => {handleClose()}}
        titleStyle={{ fontWeight: 500, fontSize: "1.3rem !important" }}
        title={`Transfer ${data?.tokenName ? data.tokenName.toUpperCase() : "FRAX"} - ${
          data?.propertyName || ""
        }`}
        children={
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            context={{ selectedDltAccount, dltWallet }}
            onSubmit={async (values, { resetForm }) => {
              // Prepare summary data and show summary modal
              const transferData = {
                sender: {
                  dltAccount: data?.dltAccount,
                  entityId: data?.entityId || userId,
                  entityType: data?.entityType || "PERSONAL",
                  investorId: userId,
                },
                receiver: {
                  dltAccount: addressDetails?.publicAddress,
                  legalName: addressDetails?.legalName,
                  entityType: addressDetails?.entityType,
                  entityId: addressDetails?.entityId,
                  investorId: addressDetails?.investorId,
                  email: addressDetails?.email,
                  mobile: addressDetails?.mobile,
                  inputType: addressDetails?.inputType
                },
                rpf: data.children?.[0]?.totalAmountInvested/data.children?.[0]?.totalTokens,
                amount:Math.ceil(Number(values.transferQuantity)*(data.children?.[0]?.totalAmountInvested/data.children?.[0]?.totalTokens)),
                numberOfToken: Number(values.transferQuantity),
                listingId: data?.listingId,
                tokenName: data?.tokenName || "FRAX",
                blockChainAssetId: data?.blockChainAssetId
              };
              setSummaryData(transferData);
              setShowSummaryModal(true);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              resetForm,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ px: 1 }}>
                  <Stack spacing={2}>
                    <Divider />
                    <Stack direction="row" gap={6} flexWrap="wrap">
                      <Box>
                        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                          Asset Name
                        </Typography>
                        <Typography variant="body1">{data?.propertyName}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                          Token Symbol
                        </Typography>
                        <Typography variant="body1">
                          {data?.tokenName ? data.tokenName.toUpperCase() : "FRAX"}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                          Tokens Owned
                        </Typography>
                        <Typography variant="body1">
                          {data?.frax || 0}
                        </Typography>
                      </Box>
                    </Stack>
                    <Divider />

                    <TextField
                      fullWidth
                      label="Recipient's Public Id / Email / Mobile"
                      placeholder="Enter recipient's address, email, or mobile"
                      name="transferToAddress"
                      value={values.transferToAddress}
                      onChange={(e) => {
                        handleChange(e);
                        const inputValue = e.target.value.trim();
                        if (!inputValue) {
                          setAddressDetails(null);
                          setAddressError(null);
                        }
                        const publicAddressRegex = /^[A-Z2-7]{58}$/;
                        if (publicAddressRegex.test(inputValue)) {
                          const isSenderAddress = dltWallet===inputValue;
                          if (isSenderAddress) {
                            setAddressError("You cannot transfer tokens to your own DLT account");
                            setAddressDetails(null);
                          } else {
                            setAddressError(null);
                          }
                        } else {
                          setAddressError(null);
                        }
                        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
                        debounceTimerRef.current = setTimeout(() => {
                          setDebouncedRecipientInput(inputValue);
                        }, DEBOUNCE_DELAY);
                      }}
                      onBlur={handleBlur}
                      error={touched.transferToAddress && Boolean(errors.transferToAddress)}
                      helperText={touched.transferToAddress && errors.transferToAddress}
                      InputProps={{
                        endAdornment: loadingAddress && (
                          <InputAdornment position="end">
                            <CircularProgress size={20} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {addressDetails && (
                      <Box sx={{
                        p: 2,
                        bgcolor: 'success.light',
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'success.main'
                      }}>
                        <Typography variant="subtitle2" sx={{ color: 'success.main', mb: 1 }}>
                          Recipient Details
                        </Typography>
                        {addressDetails.legalName && (
                          <Typography variant="body2">
                            <strong>Legal Name:</strong> {addressDetails.legalName}
                          </Typography>
                        )}
                        {addressDetails.entityType && (
                          <Typography variant="body2">
                            <strong>Entity Type:</strong> {addressDetails.entityType}
                          </Typography>
                        )}
                        {addressDetails.maskedMobileNumber && (
                          <Typography variant="body2">
                            <strong>Mobile Number:</strong> {addressDetails.maskedMobileNumber}
                          </Typography>
                        )}
                        {addressDetails.email && (
                          <Typography variant="body2">
                            <strong>Email:</strong> {addressDetails.email}
                          </Typography>
                        )}
                        {addressDetails.dltAccount && (
                          <Typography variant="body2">
                            <strong>DLT Account:</strong> {addressDetails.dltAccount}
                          </Typography>
                        )}
                      </Box>
                    )}
                    {addressError && (
                      <Box sx={{
                        p: 2,
                        bgcolor: 'error.light',
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'error.main'
                      }}>
                        <Typography variant="body2" sx={{ color: 'error.main' }}>
                          {addressError}
                        </Typography>
                      </Box>
                    )}
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        label="Quantity to Transfer"
                        placeholder="Enter number of tokens"
                        name="transferQuantity"
                        value={values.transferQuantity}
                        onChange={e => {
                          const newQuantity = e.target.value;
                          setFieldValue("transferQuantity", newQuantity);
                          setTimeout(() => {
                            const quantity = Number(newQuantity) || 0;
                            const rate = Number(values.tokenPerRate) || 0;
                            const newTotal = Math.ceil(quantity * rate);
                            setFieldValue("totalAmount", isNaN(newTotal) || newTotal === 0 ? "" : newTotal);
                          }, 0);
                        }}
                        onBlur={handleBlur}
                        inputProps={{ min: 1, max: data?.frax || 0 }}
                        error={touched.transferQuantity && Boolean(errors.transferQuantity)}
                        helperText={touched.transferQuantity && errors.transferQuantity}
                      />
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    {/* Terms & Conditions Section */}
                    <Box sx={{
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2,
                      p: 3,
                      bgcolor: 'background.paper'
                    }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                        Terms & Conditions
                      </Typography>
                      <Stack spacing={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={termsAccepted.peerToPeer}
                              onChange={handleTermsChange('peerToPeer')}
                              sx={{
                                color: 'primary.main',
                                '&.Mui-checked': { color: 'primary.main' }
                              }}
                            />
                          }
                          label={
                            <Typography variant="body2">
                              I understand that this is a peer-to-peer token transfer
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={termsAccepted.poolHolding}
                              onChange={handleTermsChange('poolHolding')}
                              sx={{
                                color: 'primary.main',
                                '&.Mui-checked': { color: 'primary.main' }
                              }}
                            />
                          }
                          label={
                            <Typography variant="body2">
                              I acknowledge that tokens will be held in RealX Pool until transaction completion
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={termsAccepted.transactionFees}
                              onChange={handleTermsChange('transactionFees')}
                              sx={{
                                color: 'primary.main',
                                '&.Mui-checked': { color: 'primary.main' }
                              }}
                            />
                          }
                          label={
                            <Typography variant="body2">
                              I agree that transaction fees may apply as per platform policy
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={termsAccepted.legalRight}
                              onChange={handleTermsChange('legalRight')}
                              sx={{
                                color: 'primary.main',
                                '&.Mui-checked': { color: 'primary.main' }
                              }}
                            />
                          }
                          label={
                            <Typography variant="body2">
                              I confirm that I have the legal right to transfer these tokens
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={termsAccepted.allTerms}
                              onChange={handleTermsChange('allTerms')}
                              sx={{
                                color: 'primary.main',
                                '&.Mui-checked': { color: 'primary.main' }
                              }}
                            />
                          }
                          label={
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              I agree to all the above terms and conditions
                            </Typography>
                          }
                        />
                      </Stack>
                    </Box>

                    <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={isSubmitting || !areAllTermsAccepted}
                      >
                        Submit
                      </Button>
                    </Stack>
                  </Stack>
                </Box>
              </Form>
            )}
          </Formik>
        }
      />

      {/* Transaction Summary Modal */}
      <Dialog
        open={showSummaryModal}
        onClose={() => setShowSummaryModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem" }}>
          Transfer Summary
          <IconButton
            aria-label="close"
            onClick={() => setShowSummaryModal(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Paper elevation={0} sx={{bgcolor: 'grey.50', borderRadius: 2 }}>
            <Grid container spacing={3}>
              {/* Asset Details */}
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
                  Transfer Details
                </Typography>
                <Stack spacing={1}>
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} spacing={2}>
                    <Typography variant="body2" color="text.secondary">Property:</Typography>
                    <Typography variant="body2" textAlign="right" fontWeight={500}>{data?.propertyName}</Typography>
                  </Stack>
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} spacing={3.7}>
                    <Typography variant="body2" color="text.secondary">Token:</Typography>
                    <Typography variant="body2" fontWeight={500}>{summaryData?.tokenName ? summaryData?.tokenName.toUpperCase() : "FRAX"}</Typography>
                  </Stack>
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} spacing={2}>
                    <Typography variant="body2" color="text.secondary">Number of Tokens:</Typography>
                    <Typography variant="body2" fontWeight={500}>{summaryData?.numberOfToken}</Typography>
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>

              {/* Sender Details */}
              <Grid item xs={12} md={6} sx={{borderRight:"1px solid", borderColor:"divider", p:2, bgcolor:"grey.50"}}>
                <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
                  From (Sender)
                </Typography>
                <Stack spacing={2}>
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} alignItems="flex-start" spacing={1}>
                    <Typography variant="body2" color="text.secondary">DLT Account:</Typography>
                    <Tooltip
                      title={summaryData?.sender?.dltAccount || ""}
                      arrow
                      placement="top"
                      disableInteractive={isMobile}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        textAlign="right"
                        title={summaryData?.sender?.dltAccount || ""}
                        sx={{
                          flex: 1,
                          ...(isMobile
                            ? {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }
                            : { wordBreak: "break-all" }),
                        }}
                      >
                        {formatAddressShort(summaryData?.sender?.dltAccount)}
                      </Typography>
                    </Tooltip>
                  </Stack>
                  {data?.legalName && (
                    <Stack direction="row" justifyContent={isMobile ? "space-between" : ""}  spacing={2}>
                      <Typography variant="body2" color="text.secondary">Legal Name:</Typography>
                      <Typography variant="body2" fontWeight={500}>{data?.legalName}</Typography>
                    </Stack>
                  )}
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} spacing={2}>
                    <Typography variant="body2" color="text.secondary">Entity Type:</Typography>
                    <Typography variant="body2" fontWeight={500}>{summaryData?.sender?.entityType}</Typography>
                  </Stack>
                  
                </Stack>
              </Grid>

              {/* Receiver Details */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
                  To (Receiver)
                </Typography>
                <Stack spacing={1}>
                  <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} alignItems="flex-start" spacing={2}>
                    <Typography variant="body2" color="text.secondary">DLT Account:</Typography>
                    <Tooltip
                      title={summaryData?.receiver?.dltAccount || ""}
                      arrow
                      placement="top"
                      disableInteractive={isMobile}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        textAlign="right"
                        title={summaryData?.receiver?.dltAccount || ""}
                        sx={{
                          flex: 1,
                          ...(isMobile
                            ? {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }
                            : { wordBreak: "break-all" }),
                        }}
                      >
                        {formatAddressShort(summaryData?.receiver?.dltAccount)}
                      </Typography>
                    </Tooltip>
                  </Stack>
                  {summaryData?.receiver?.legalName && (
                    <Stack direction="row" justifyContent={isMobile ? "space-between" : ""}  spacing={2}>
                      <Typography variant="body2" color="text.secondary">Legal Name:</Typography>
                      <Typography variant="body2" fontWeight={500}>{summaryData?.receiver?.legalName}</Typography>
                    </Stack>
                  )}
                  {summaryData?.receiver?.email && (
                    <Stack direction="row" justifyContent={isMobile ? "space-between" : ""} spacing={2}>
                      <Typography variant="body2" color="text.secondary">Email:</Typography>
                      <Typography variant="body2" fontWeight={500}>{summaryData?.receiver?.email}</Typography>
                    </Stack>
                  )}
                  {summaryData?.receiver?.mobile && (
                    <Stack direction="row" justifyContent={isMobile ? "space-between" : ""}  spacing={2}>
                      <Typography variant="body2" color="text.secondary">Mobile:</Typography>
                      <Typography variant="body2" fontWeight={500}>{summaryData?.receiver?.mobile}</Typography>
                    </Stack>
                  )}
                  {summaryData?.receiver?.entityType && (
                    <Stack direction="row" justifyContent={isMobile ? "space-between" : ""}  spacing={3}>
                      <Typography variant="body2" color="text.secondary">Entity Type:</Typography>
                      <Typography variant="body2" fontWeight={500}>{summaryData?.receiver?.entityType}</Typography>
                    </Stack>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => {
              handleFinalSubmit();
            }}
            variant="contained"
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mnemonic Upload Modal */}
      <MnemonicUploadModal
        open={showMnemonicModal}
        onClose={() => {setShowMnemonicModal(false);}}
        transactionId={trnasactionId}
        closeAll={handleClose}
      />
      <TransferInitiated open={transferInitiatedModal}/>


    <ModalComponent open={showOptinModal} handleClose={()=>{setShowOptinModal(false);handleClose();}}>
       <Box sx={{textAlign:'center', bgcolor:'#fdedec',borderRadius:2,}}>
        <Stack rowGap={2} sx={{ padding: 3, alignItems: 'center', minWidth: { md: '600px' } }}>
          {
            animating &&
            <Box sx={{ width: 150, marginTop: "-35px" }}>
              <Lottie animationData={warning} loop={true} />
            </Box>

          }
          <Typography variant='landingSubTitle' sx={{ textAlign: 'center' }}>
            The receiver has not opted in to this asset yet.
            <br />
            Please complete the opt-in process for the receiver
            <br />
            to proceed with the transfer.
            <br />
            Once the opt-in is completed, you will be able
            <br />
            to proceed with the transfer.
          </Typography>
        </Stack>   
       </Box>
    </ModalComponent>
    </>
  );
};

export default TransferTokenModal;
